export const TrainingNewAzureSearchTypesConstants = {
  TRAINING_NEW_AZURE_SEARCH: 'TRAINING_NEW_AZURE_SEARCH',
  TRAINING_NEW_LAST_SEARCH: 'TRAINING_NEW_LAST_SEARCH',
  TRAINING_FREE_COURSE_COUNT: 'TRAINING_FREE_COURSE_COUNT',
};
